import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/icons/Logo_orange.png';

const Footer = () => {
  const {t} = useTranslation();
  const footerLinks = {
    product: [
      { name: t("footer.links.marketplace"), href: '/marketplace' },
      // { name: t("footer.links.crm_dashboard"), href: '/dashboard' },
      // { name: t("footer.links.ai_assistants"), href: '/ai' },
      // { name: t("footer.links.mobile_app"), href: '/mobile' }
    ],
    company: [
      { name: t("footer.links.about_us"), href: '/about' },
      // { name: t("footer.links.careers"), href: '/careers' },
      // { name: t("footer.links.press"), href: '/press' },
      // { name: t("footer.links.contact"), href: '/contact' }
    ],
    legal: [
      { name: t("footer.links.privacy"), href: '/privacy' },
      { name: t("footer.links.terms"), href: '/terms' },
      { name: t("footer.links.escrow_policy"), href: '/escrow' },
      { name: t("footer.links.cookie_policy"), href: '/cookies' }
    ]
  };

  return (
    <footer className="bg-white pt-24 pb-12 px-6 font-['Inter']">
      <div className="max-w-7xl mx-auto">
        
        {/* ВЕРХНЯЯ ЧАСТЬ: КОЛОНКИ */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-24">
          
          {/* Логотип и слоган */}
          <div className="lg:col-span-2">
            <div className="mb-8">
              {/* Оригинальный логотип без лишнего текста рядом */}
              <img 
                src={logo} 
                alt="Zootel" 
                className="h-10 w-auto object-contain" 
              />
            </div>
            <p className="text-slate-400 font-medium text-[17px] leading-relaxed max-w-[300px]">
              {t("footer.slogan")}
            </p>
          </div>

          {/* Ссылки: Product */}
          <div>
            <h3 className="text-[#0A1128] font-[900] uppercase tracking-[2px] text-[11px] mb-8">{t("footer.columns.product")}</h3>
            <ul className="space-y-4">
              {footerLinks.product.map((link) => (
                <li key={link.name}>
                  <Link to={link.href} className="text-slate-400 hover:text-[#F65814] font-semibold text-[15px] transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Ссылки: Company */}
          <div>
            <h3 className="text-[#0A1128] font-[900] uppercase tracking-[2px] text-[11px] mb-8">{t("footer.columns.company")}</h3>
            <ul className="space-y-4">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link to={link.href} className="text-slate-400 hover:text-[#F65814] font-semibold text-[15px] transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Ссылки: Legal */}
          {/* <div>
            <h3 className="text-[#0A1128] font-[900] uppercase tracking-[2px] text-[11px] mb-8">{t("footer.columns.legal")}</h3>
            <ul className="space-y-4">
              {footerLinks.legal.map((link) => (
                <li key={link.name}>
                  <Link to={link.href} className="text-slate-400 hover:text-[#F65814] font-semibold text-[15px] transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div> */}
        </div>

        {/* НИЖНЯЯ ПАНЕЛЬ: COPYRIGHT & COMPLIANCE */}
        <div className="border-t border-gray-100 pt-10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-8">
            <div className="text-slate-300 font-black uppercase tracking-[1px] text-[10px]">
              {t("footer.rights")}
            </div>
            
            <div className="flex items-center gap-8 opacity-40 grayscale transition-opacity hover:opacity-100">
              {/* Stripe Logo */}
              <span className="font-black text-[18px] text-slate-400 tracking-tighter">stripe</span>
              
              {/* PCI-DSS */}
              <div className="flex items-center gap-2">
                <svg className="w-4 h-4 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
                <span className="font-black uppercase tracking-[1px] text-[10px] text-slate-500">{t("footer.compliance")}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
